import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  appsLoaded: false,
  selectedApp: null,
  selectedAgentSiteCode: null,
  selectedAgentName: null,
  selectedAgentMode: null,
};

const appsSlice = createSlice({
  name: "apps",
  initialState,
  reducers: {
    // Action to save the list of apps
    saveApps: (state, action) => {
      localStorage.setItem("apps", JSON.stringify(action.payload));
      state.list = action.payload;
      state.appsLoaded = true;
    },
    // Action to select an app
    selectApp: (state, action) => {
      localStorage.setItem("selectedApp", JSON.stringify(action.payload));
      state.selectedApp = action.payload;
    },

    initializeApp: (state, action) => {
      state.selectedApp = action.payload;
    },

    markAppsLoaded: (state) => {
      state.appsLoaded = true;
    },

    setSelectedAgentSiteCode: (state, action) => {
      localStorage.setItem("selectedAgentSiteCode", action.payload);
      state.selectedAgentSiteCode = action.payload;
    },
    setSelectedAgentName: (state, action) => {
      localStorage.setItem("selectedAgentName", action.payload || "");
      state.selectedAgentName = action.payload;
    },
    setSelectedAgentMode: (state, action) => {
      localStorage.setItem("selectedAgentMode", action.payload || "");
      state.selectedAgentMode = action.payload;
    },
  },
});

export const { saveApps, selectApp, initializeApp, markAppsLoaded, setSelectedAgentSiteCode, setSelectedAgentName, setSelectedAgentMode } =
  appsSlice.actions;
export default appsSlice.reducer;
